
import { authFetch } from '../AuthFetch';

export const forwardToSetAppendCheckItemModalVisibility = (category, ckSet, visibility) => (
  (dispatch) => {
    dispatch({
      type: 'SWITCH_CHECK_ITEM_MODAL_VISIBILITY',
      payload: {
        category: category,
        ckSet: ckSet,
        visibility: visibility,
      }
    });
  }
);

export const forwardToSetCheckItemDescription = (description) => (
  (dispatch) => {
    dispatch({
      type: 'SET_CHECK_ITEM_MODAL_DESCRIPTION',
      payload: description
    });
  }
);

export const forwardToSetCheckItemPrice = (price) => (
  (dispatch) => {
    dispatch({
      type: 'SET_CHECK_ITEM_MODAL_PRICE',
      payload: price
    });
  }
);

export const forwardToSetCheckItemNote = (note) => (
  (dispatch) => {
    dispatch({
      type: 'SET_CHECK_ITEM_MODAL_NOTE',
      payload: note
    });
  }
);

export const forwardToSetHideCheckItemModal = () => (
  (dispatch) => {
    dispatch({
      type: 'HIDE_CHECK_ITEM_MODAL',
      payload: null
    });
  }
);

export const forwardToSetCheckItemAvailable = (checkItem) => (
  (dispatch) => {
    let request = { id: checkItem.id }
    let url = '/maintenance/check/items/' + checkItem.id;
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: 'FIND_CATEGORIES',
        payload: json
      });
    });
  }
);

export const forwardToDeleteCheckItem = (ckItemId) => (
  (dispatch) => {
    let url = '/maintenance/check/items/' + ckItemId;
    authFetch('DELETE', url, null, (json) => {
      dispatch({
        type: 'FIND_CATEGORIES',
        payload: json
      });
    });
  }
);

export const forwardToAppendCheckItem = (checkSet, desc, price, note) => (
  (dispatch) => {
    let request = {
      setId: checkSet.id,
      description: desc,
      price: price,
      note: note,
      show: true,
      positionId: 1
    }
    let url = '/maintenance/check/items/';
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: 'FIND_CATEGORIES',
        payload: json
      });
    });
  }
);


// WEBPACK FOOTER //
// ./src/actions/manageCheckItemAction.js